var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.683594,
    y: 0.644531,
    width: 68.6176,
    height: 68.6176,
    rx: 9.80251,
    fill: "#FFEED4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_926_57657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1692 22.3823C22.8806 23.9874 19.3701 25.3169 19.3701 25.3353C19.3701 25.3537 22.8868 26.6831 27.1815 28.2883L34.9929 31.2168L37.9152 30.1201L40.8437 29.0235L40.5068 28.8703C40.323 28.7907 39.0058 28.2454 37.5783 27.6573C35.1399 26.6586 34.9929 26.5851 35.1583 26.5177C35.2502 26.481 36.1385 26.1072 37.1249 25.6845L38.92 24.9187L41.8485 26.2298L44.7831 27.547L47.6994 26.4565C49.3045 25.856 50.6156 25.3537 50.6156 25.3353C50.6156 25.3108 35.2808 19.5518 35.0235 19.4783C34.9929 19.466 31.4517 20.7771 27.1692 22.3823Z",
    fill: "#EE9C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3208 36.1236L19.3392 44.952L26.6605 47.6967L33.9817 50.4414L34.0001 41.6437C34.0062 36.8037 33.994 32.8275 33.9695 32.8091C33.9388 32.7846 30.8082 31.6022 26.9974 30.1747C23.1928 28.7472 19.9029 27.5158 19.6884 27.4423L19.3086 27.2952L19.3208 36.1236ZM25.1901 42.1767L27.12 42.8996L27.1384 43.9472C27.1445 44.5293 27.1445 45.001 27.1384 45.001C27.1261 45.001 26.25 44.6763 25.1901 44.2719L23.2602 43.549L23.2419 42.5014C23.2357 41.9193 23.2357 41.4476 23.2419 41.4476C23.2541 41.4476 24.1302 41.7723 25.1901 42.1767Z",
    fill: "#EE9C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7357 28.3984L44.8256 29.489L44.7949 31.958L44.7643 34.4209L42.8344 35.1438C41.7745 35.5482 40.8984 35.8729 40.8923 35.8729C40.88 35.8729 40.8678 34.7701 40.8617 33.4284L40.8433 30.9839L38.4233 31.8906L36.0033 32.7973L35.9849 41.6257L35.9727 50.4541L36.3525 50.3071C36.5669 50.2335 39.8569 49.0021 43.6615 47.5746C47.4722 46.1471 50.6029 44.9647 50.6335 44.9402C50.658 44.9218 50.6703 40.9457 50.6642 36.1057L50.6458 27.3079L47.7357 28.3984Z",
    fill: "#EE9C1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_57657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.368,
    height: 31.368,
    fill: "white",
    transform: "translate(19.3086 19.2695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseRejected);
export default __webpack_public_path__ + "static/media/caseRejected.a0a335adb92cdb96bb3afb5c4ded22de.svg";
export { ForwardRef as ReactComponent };